import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {BufferContent} from 'buffers/BufferComps';
import {BufferViewType, TabViewWithOptionalAfterAttachCallback} from 'buffers/BufferTypes';
import {TabState} from 'Navigation';
import {GenericBackboneViewClass, Optional} from 'util/Types';

export default function PolymerMapWrapper({
  className,
  tabState,
  TabOptionsViewCls,
  TabContentViewCls,
}: {
  className?: string;
  tabState: Optional<TabState>;
  TabOptionsViewCls: GenericBackboneViewClass<TabState, Backbone.View<TabState>>;
  TabContentViewCls: GenericBackboneViewClass<TabState, TabViewWithOptionalAfterAttachCallback>;
}): JSX.Element {
  return (
    <div className={classNames('reset', className)}>
      {/* The maps depends on some LESS styles inherited from #buffers and .buffer-container
          so apply them here */}
      <div id="buffers" className={css(styles.buffers)}>
        <div className="buffer-container">
          <BufferContent
            tabContentMetadata={{TabView: TabContentViewCls, tabViewType: BufferViewType.BACKBONE}}
            tabOptionsMetadata={{OptionsView: TabOptionsViewCls, optionsViewType: BufferViewType.BACKBONE}}
            tabState={tabState}
          />
        </div>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  buffers: {
    // Usually there is space reserved for the statusbar and toolbar, so override that.
    bottom: '0',
    right: '0',
    height: '100%',
  },
});
